module.exports = __webpack_public_path__ + "img/uploadditdocs.09cd328a.webp";